import { AQIDataItem } from "./types";

export const transformAQI = (rawAQI: any[]): AQIDataItem[] => {
  const filteredAQI = rawAQI
    .filter((item) => {
      if (!item?.aqi || item.aqi === "" || item.aqi === null) {
        console.log("item.aqi is empty");
        return false;
      }
      if (!item?.lat || item.lat === "" || item.lat === null) {
        console.log("item.lat is empty");
        return false;
      }
      if (!item?.long || item.long === "" || item.long === null) {
        console.log("item.long is empty");
        return false;
      }
      if (!item?.upddate || item.upddate === "" || item.upddate === null) {
        console.log("item.upddate is empty");
        return false;
      }
      if (!item?.stncode || item.stncode === "" || item.stncode === null) {
        console.log("item.stncode is empty");
        return false;
      }
      if (!item?.stnname || item.stnname === "" || item.stnname === null) {
        console.log("item.stnname is empty");
        return false;
      }
      if (!item?.color || item.color === "" || item.color === null) {
        console.log("item.color is empty");
        return false;
      }
      return true;
    })
    .map((item) => {
      const newItem: AQIDataItem = {
        pm25: parseFloat(String(item.pm25).trim()),
        aqi: parseInt(String(item.aqi).trim()),
        color: String(item.color).trim(),
        long: parseFloat(String(item.long).trim()),
        lat: parseFloat(String(item.lat).trim()),
        remark: String(item.remark).trim(),
        stncode: String(item.stncode).trim(),
        stnname: String(item.stnname).trim(),
        updtime: String(item.updtime).trim(),
        upddate: String(item.upddate).trim(),
        district:
          item?.district || item.district !== null
            ? String(item.district).trim()
            : "Others",
      };
      return newItem;
    });
  const ReturnableAQI = filteredAQI.filter((item) => {
    if (item.aqi < 0) return false;
    if (item.aqi > 500) return false;
    if (item.lat < 0) return false;
    if (item.lat > 90) return false;
    if (item.long < 0) return false;
    if (item.long > 180) return false;
    //@ts-ignore
    if (item.lat === NaN) return false;
    //@ts-ignore
    if (item.long === NaN) return false;
    return true;
  });
  return ReturnableAQI;
};
